import React from 'react';
import PropTypes from 'prop-types';
import MList from '../../atoms/list';
import Image from '../../atoms/image/Image';
import TextItem from '../../atoms/label';
import HotelContact from '../Hotel/hotelContact';
import HotelPolicies from '../Hotel/hotelPolicies';
import TravelTips from '../../molecules/travelTips';

const HotelSummary = ({
  className, children, booking, email, locator, lang,
}, context) => {
  const { hotel } = booking;
  const contact = [
    {
      icon: 'phone',
      title: hotel.phone,
      component: 'phone',
    },
    {
      icon: 'mail',
      title: hotel.mail,
      component: 'mail',
    },
    {
      icon: 'chat',
      title: hotel.chat,
      component: 'chat',
    },
  ];
  const travelTips = booking.travel_tips || null;
  return (
  <div className={`${className || ''}`}>
    <div className="relative | bg-primary-500 text-white">
      <Image alt="Room Image" className="w-full h-56 object-cover opacity-75" img={hotel.photos[0].url}/>
      <div className="absolute top-0 inset-x-0 | px-4 py-2 ">
      <TextItem icon="logo-sm" className="text-sm">{hotel.name}</TextItem>
      </div>
    </div>
    <div className="px-4 mt-4 | text-xl text-gray-700">
      {context.t('Hotel details')}
    </div>

    <address className="mx-4 mb-4 not-italic">
      {hotel.address}<br/>
      {hotel.city.code}, {hotel.city.name}<br/>
      {hotel.city.zone.name},  {hotel.city.zone.country.name}
    </address>
    <div className="flex flex-wrap px-2 mb-4">
    {hotel.arrival_time && <div className="px-2"> {context.t('Check-in')} <div className="text-lg text-bold">{hotel.arrival_time}</div></div>}
    {hotel.departure_time && <div className="px-2">{context.t('Check-out')}<div className="text-lg text-bold">{hotel.departure_time}</div></div>}
    </div>
    <MList items={contact} variant="contact" className="mx-4 font-bold" iconClassName="text-primary" >
    <HotelContact email={email} locator={locator}/>
    <HotelPolicies hotel={booking.hotel} lang={lang}/>
    </MList>
    <TravelTips travelTips={travelTips}/>
    {children}
  </div>
  );
};

HotelSummary.contextTypes = {
  t: PropTypes.func.isRequired,
};
export default HotelSummary;
